/*
  Sonder counter animation
  ========================
  When an element with class .sonder-counter enters the viewport, its
  numeric content animates from 0 to the final value. Preserves any
  prefix (+, -, $) and suffix (%, etc.). Re-fires every time the
  element re-enters (matches Sonder's reveal behavior).

  Usage: just add class="sonder-counter" to any element whose text is
  a number with optional non-digit prefix/suffix.

    <div class="sonder-counter">+10,000</div>     → counts 0 → 10,000
    <div class="sonder-counter">70%</div>         → counts 0 → 70%
    <div class="sonder-counter">70 to 80%</div>   → counts 0 → 70 to 80%
                                                    (animates first number)

  Honors prefers-reduced-motion (skips animation, shows final value).
*/
(function () {
  if (typeof window === 'undefined') return;

  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DURATION = 1200; // ms — slow enough to be noticed, fast enough not to feel stuck

  function parse(text) {
    // Match optional non-digit prefix, then a number (with commas / dots), then anything after
    var m = text.match(/^([^\d-]*)(-?[\d,]+)([\s\S]*)$/);
    if (!m) return null;
    var prefix = m[1];
    var raw = m[2];
    var suffix = m[3];
    var numeric = parseFloat(raw.replace(/,/g, ''));
    if (isNaN(numeric)) return null;
    var hasCommas = raw.indexOf(',') !== -1;
    return { prefix: prefix, suffix: suffix, target: numeric, hasCommas: hasCommas };
  }

  function format(n, hasCommas) {
    var rounded = Math.round(n);
    if (!hasCommas) return String(rounded);
    return rounded.toLocaleString('en-US');
  }

  function animate(el) {
    var original = el.getAttribute('data-counter-original');
    if (!original) {
      original = el.textContent.trim();
      el.setAttribute('data-counter-original', original);
    }
    var parts = parse(original);
    if (!parts) return;

    if (prefersReduced) {
      el.textContent = original;
      return;
    }

    var start = performance.now();
    function step(now) {
      var t = Math.min(1, (now - start) / DURATION);
      // ease-out cubic
      var eased = 1 - Math.pow(1 - t, 3);
      var current = parts.target * eased;
      el.textContent = parts.prefix + format(current, parts.hasCommas) + parts.suffix;
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function reset(el) {
    var original = el.getAttribute('data-counter-original');
    if (!original) return;
    var parts = parse(original);
    if (!parts) return;
    el.textContent = parts.prefix + format(0, parts.hasCommas) + parts.suffix;
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.sonder-counter').forEach(function (el) {
      animate(el);
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animate(entry.target);
      } else {
        reset(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

  function bind() {
    document.querySelectorAll('.sonder-counter').forEach(function (el) {
      // Initialize at zero so the first reveal animates from 0, not from final
      reset(el);
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
